<template><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14.104 14.003">
    <g transform="translate(0.072 0.002)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M536.291,317.241a.832.832,0,0,0-.541.781v3.125a.834.834,0,0,0,.541.778l2.5.937a.837.837,0,0,0,.586,0l2.5-.937a.833.833,0,0,0,.541-.778v-3.125a.833.833,0,0,0-.541-.781l-2.5-.937a.831.831,0,0,0-.586,0Z"
              transform="translate(-535 -309.667)"/>
        <path d="M536.008,318.6l3.19,1.2,3.19-1.2" transform="translate(-535.115 -310.71)"/>
        <path d="M541.75,320.75v4.167" transform="translate(-537.667 -311.667)"/>
        <path d="M550.217,308.85l-4.833,1.611-4.833-1.611" transform="translate(-537.133 -306.378)"/>
        <path d="M549.25,311.75v2.083" transform="translate(-541 -307.667)"/>
        <path d="M540.25,309.917v-1.944a.833.833,0,0,1,.57-.791l4.167-1.389a.829.829,0,0,1,.527,0l4.167,1.389a.833.833,0,0,1,.57.791v4.722a.833.833,0,0,1-.57.791l-3.6,1.2"
              transform="translate(-537 -305)"/>
    </g>
</svg>
</template>